
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"image-placeholder"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.731 18.125a1.25 1.25 0 01-1.25 1.25H2.519a1.25 1.25 0 01-1.25-1.25V1.875A1.25 1.25 0 012.52.625h12.5c.326 0 .64.127.873.355l2.462 2.402a1.25 1.25 0 01.377.895v13.848z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.02 6.25a1.875 1.875 0 103.75 0 1.875 1.875 0 00-3.75 0v0zm10.658 8.917l-3.271-4.907a.843.843 0 00-1.393-.016l-2.242 3.204-1.39-1.115a.842.842 0 00-1.229.191l-1.759 2.643","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    